import { render, staticRenderFns } from "./resourceDetail.vue?vue&type=template&id=0fb7438c&scoped=true"
import script from "./resourceDetail.vue?vue&type=script&lang=js"
export * from "./resourceDetail.vue?vue&type=script&lang=js"
import style0 from "./resourceDetail.vue?vue&type=style&index=0&id=0fb7438c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb7438c",
  null
  
)

export default component.exports